<template>
  <div class="table-page-search-wrapper collection-config">
    <div class="actions-bar">
      <a-button type="primary" icon="plus" @click="handleAdd">Add</a-button>
    </div>

    <a-table
      :columns="columns"
      :dataSource="configs"
      :pagination="false"
      :loading="loading"
      rowKey="id"
      bordered
    >
      <template slot="status" slot-scope="text, record">
        <a-tag :color="record.status == '1' ? 'green' : 'red'">
          {{ record.status == '1' ? 'Valid' : 'Invalid' }}
        </a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">Edit</a>
        <a-divider type="vertical" />
        <!-- <a @click="configureRule(record)">Config rules</a> -->
      </template>
    </a-table>
    <div style="margin-top: 15px; text-align: right;">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange"
      />
    </div>
 
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :confirmLoading="saving"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
    >
      <a-form
        ref="configForm"
        :model="formModel"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="ConfigurationName" prop="name">
          <a-input
            v-model="formModel.name"
            :maxLength="40"
            placeholder="Please enterConfigurationName"
          />
        </a-form-item>
        <a-form-item label="Status" prop="status">
          <a-radio-group v-model="formModel.status">
            <a-radio value="1">Valid</a-radio>
            <a-radio value="0">Invalid</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getPageFirst, saveOrUpdateFirst } from '@/webpublicapi/collection'
import { filterObj } from '@/utils/util'

export default {
  name: 'CollectionConfig',
  data() {
    return {
      configs: [],
      loading: false,
      total: 0,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30
      },
      modalVisible: false,
      isEdit: false,
      saving: false,
      formModel: {
        id: undefined,
        name: '',
        status: ''
      },
      rules: {
        name: [
          { required: true, message: 'Please enterConfigurationName', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Please select status', trigger: 'change' }
        ]
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      columns: [
        {
          title: 'ConfigurationName',
          dataIndex: 'name',
          align: 'left'
        },
        {
          title: 'Status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 180
        }
      ]
    }
  },
  created() {
    this.loadData();
  },
  computed: {
    modalTitle() {
      return this.isEdit ? 'EditConfiguration' : 'AddConfiguration'
    }
  },
  methods: {
    loadData() {
      this.loading = true
      const params = this.getQueryParams()
      getPageFirst(params).then(res => {
        if (res.code === 1000) {
          this.total = res.data.total || 0
          this.configs = res.data.list || res.data.rows || []
        } else {
          this.total = 0
          this.configs = []
          this.$message.error(res.msg || 'Query failed')
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message || 'Query failed')
      })
    },
    getQueryParams() {
      const param = {
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    resetForm() {
      this.formModel = {
        id: undefined,
        name: '',
        status: '1'
      }

    },
    handleAdd() {
      this.isEdit = false
      this.resetForm()
      this.modalVisible = true
    },
    handleEdit(record) {
      this.isEdit = true
      this.formModel = { ...record }
      console.log(this.formModel)
      this.formModel.status = this.formModel.status == '1' ? '1' : '0'
      this.modalVisible = true
    },
    configureRule(record) {
      this.$message.info(`Config Rules:${record.name}`)
    },
    handleModalOk() {
       if(!this.formModel.status) {
        this.$message.error('Please select status')
        return
       }
       if(!this.formModel.name) {
        this.$message.error('Please enterConfigurationName')
        return
       }
        this.saving = true
        saveOrUpdateFirst(this.formModel).then(res => {
          if (res.code === 1000) {
            this.$message.success('Saved successfully')
            this.modalVisible = false
            this.loadData()
          } else {
            this.$message.error(res.msg || 'Save failed')
          }
          this.saving = false
        }).catch(e => {
          this.saving = false
          this.$message.error(e.message || 'Save failed')
        })
     
    },
    handleModalCancel() {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.collection-config {
  background: #fff;
  padding: 16px;
}

.actions-bar {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}
</style>
